import { Component } from '@angular/core';
import { YouTubePlayer } from '@angular/youtube-player';
import { NguCarousel, NguTileComponent, NguCarouselDefDirective, NguCarouselNextDirective, NguCarouselPrevDirective, NguItemComponent, NguCarouselConfig } from '@ngu/carousel';
import { IYoutube, VideoService } from './video.service';
import { APPHOST } from '../../../app.component';
import { CommonModule } from '@angular/common';
const ngu = [
  NguCarousel,
  NguTileComponent,
  NguCarousel,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent
]
@Component({
  selector: 'app-videos',
  standalone: true,
  imports: [YouTubePlayer,CommonModule, ngu],
  templateUrl: './videos.component.html',
  styleUrl: './videos.component.scss'
})
export class VideosComponent {

  public carouselTile1: NguCarouselConfig = {
    grid: { xs: 2, sm: 2, md: 3, lg: 4, xl: 4, all: 0 },
    // slide: 1,
    speed: 1500,
    point: {
      visible: true,

    },
    load: 1,
    animation: 'lazy',
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
    interval: {
      timing: 3500,
      initialDelay: 0
    },
    loop: true,


  };

  public carouselTile2: NguCarouselConfig = {
    grid: { xs: 2, sm: 2, md: 3, lg: 4, xl: 4, all: 0 },
    // slide: 1,
    speed: 1300,
    point: {
      visible: true,

    },
    load: 1,
    animation: 'lazy',
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
    interval: {
      timing: 3200,
      initialDelay: 0
    },
    loop: true,
    RTL: true

  };


  public carouselTile3: NguCarouselConfig = {
    grid: { xs: 2, sm: 2, md: 4, lg: 5, xl: 5, all: 0 },
    // slide: 1,
    speed: 1500,
    point: {
      visible: true,

    },
    load: 1,
    animation: 'lazy',
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
    interval: {
      timing: 3500,
      initialDelay: 0
    },
    loop: true,
    RTL: false

  };
  videos: IYoutube[] = [];
  shorts: IYoutube[] = [];
  vid: IYoutube[][] = [[], []];

  constructor(private vService: VideoService) {
    vService.getVideos().subscribe(w => {
      this.videos = w
      this.vid = this.chunkArray(w, 2)
    })
    vService.getSHorts().subscribe(w => {
      this.shorts = w
    })

  }

  chunk = (arr: IYoutube[], size: number) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );

  chunkArray(arr: IYoutube[], n: number) {
    var chunkLength = Math.max(arr.length / n, 1);
    var chunks: IYoutube[][] = [];
    for (var i = 0; i < n; i++) {
      if (chunkLength * (i + 1) <= arr.length) chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1)));
    }
    return chunks;
  }
  getHost(): string {
    return APPHOST;
  }
}
